import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 15
  },
  cssLabel: {
    '&$cssFocused': {
      color: 'rgba(0, 0, 0, 0.54)'
    }
  },
  cssFocused: {}
})

function DatePicker(props) {
  const { classes, placeholder, value, onChange, error = '', minDate } = props

  return (
    <form className={classes.container} noValidate>
      <InputLabel
        shrink
        FormLabelClasses={{
          root: classes.cssLabel,
          focused: classes.cssFocused
        }}
      >
        {placeholder}
      </InputLabel>
      <TextField
        id={'date'}
        type={'date'}
        value={value}
        onChange={event => onChange(event.target.value)}
        error={error !== ''}
        fullWidth
        mindate={minDate}
      />
      <FormHelperText id={'name-error-text'}>{error}</FormHelperText>
    </form>
  )
}

DatePicker.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(DatePicker)



// WEBPACK FOOTER //
// ./src/components/common/DatePicker.js